module.exports = __webpack_public_path__ + "static/media/gmail.847c083c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/contact/gmail.png
// module id = 1507
// module chunks = 0